exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flameGraphDisabledMessage{display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;padding:10px;background-color:var(--grey-20);box-shadow:inset 0 0 150px rgba(0,0,0,.1);font-size:120%}", ""]);

